import React from 'react'
import styles from './Footer.scss'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__links}>
        <ul>
          <li>
            <a
              href="/customer-services/contact-us"
              target="_blank"
              data-testid="footer-contact-us"
              rel="noopener noreferrer"
            >
              <span>Contact us</span>
            </a>
          </li>
          <li>
            <a
              href="/feedback"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="send-feedback-link"
            >
              <span>Send feedback</span>
            </a>
          </li>
          <li>
            <a
              href="/customer-services/shopping-with-us/cookies"
              target="_blank"
              data-testid="footer-cookies"
              rel="noopener noreferrer"
            >
              <span>Cookies</span>
            </a>
          </li>
          <li>
            <a
              href="/customer-services/returns/our-refund-policy"
              target="_blank"
              data-testid="footer-refund-policy"
              rel="noopener noreferrer"
            >
              <span>Refund policy</span>
            </a>
          </li>
          <li>
            <a
              href="/customer-services/shopping-with-us/security-and-privacy"
              target="_blank"
              data-testid="footer-security-copy"
              rel="noopener noreferrer"
            >
              <span>Secure shopping</span>
            </a>
          </li>
        </ul>
      </div>
      <p data-testid="footer-copyright" className={styles.footer__copyright}>
        &copy; John Lewis plc 2001 - {new Date().getFullYear()}
      </p>
    </footer>
  )
}
